import { css, Theme } from '@mui/material';

export const sidebarSectionClickableStyles = (theme: Theme) =>
  css({
    display: 'block',
    width: '100%',
    backgroundColor: 'unset',
    border: 'none',
    textDecoration: 'none',
    textAlign: 'left',
    padding: 0,
    cursor: 'pointer',

    '&:hover *': {
      color: theme.palette.lwPrimary[100],
    },
  });
